import axios from 'axios';
import ServerProperties from '../../config/server.js'

export default {
    ReadAsMaster: function(params) {
        axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
        axios.get(ServerProperties.ATM_CLOUD.API + params.data.query)
        .then(function (response) {
          params.onsuccess(params, response);
        })
        .catch(error => {
            console.log(error)
            params.onfailed(params, error)
        });
    },
    
    ReadMasterReservation: function(params) {
        axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
        axios.get(ServerProperties.ATM_CLOUD.API + 'Booking/Reservation/' + params.data.query + '/')
        .then(function (response) {
          params.onsuccess(params, response);
        })
        .catch(error => {            
            params.onfailed(error.response)
        });
    },
    
    Read: function(params) {
        axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
        axios.get( 
            ServerProperties.ATM_CLOUD.API+'Asset/Info/?page='+params.data.page+'&'+params.data.order+'&'+params.data.filter,
            {
                params:
                {
                    cluster: params.data.cluster,
                } 
            } 
        )
        .then(function (response) {
          params.onsuccess(params, response);
        })
        .catch(error => {
            console.log(error)
            params.onfailed(params, error)
        });
    },
    
    ReadMaintenanceByAsset: function(params){
        axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
        axios.get( 
            params.data.url === undefined ? ServerProperties.ATM_CLOUD.API + 'Maintenance/Work/Asset/' + params.data.query+'/' + (!params.data.isInternalAsset ? 'Global/':'') : params.data.url
        )
        .then(function (response) {
          params.onsuccess(params, response);
        })
        .catch(error => {
            console.log(error)
            params.onfailed(params, error)
        });
    },
    
    ReadTracking: function(params) {
        axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
        axios.get( 
            params.data.url === undefined ? ServerProperties.ATM_CLOUD.API+'v1/asset/'+params.data.query+'/trackings/' : params.data.url
        )
        .then(function (response) {
          params.onsuccess(params, response);
        })
        .catch(error => {
            params.onfailed(params, error)
        });
    },
    
    ReadComments: function(params) {
        axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
        axios.get( 
          params.data.url === undefined ? 
            ServerProperties.ATM_CLOUD.API+'Message/Comments/'+params.data.query+'/?ordering=-CreatedTime' 
          : 
            params.data.url
        )
        .then(function (response) {
            params.onsuccess(params, response);
        })
        .catch(error => {
          console.log(error)
          params.onfailed(params, error.response)
        });

    },
    
    RegisterComment: function(params) {
      axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
      axios.post(
        ServerProperties.ATM_CLOUD.API+'Message/Comment/',
        {
          Parent  : params.data.Parent,
          Content : params.data.Content
        }
      )
      .then(function (response) {
          params.onsuccess(params, response)
      })
      .catch(error => {
        console.log(error)
        params.onfailed(params, error.response)
      });
    },
    
    RegisterBooking: function(params) {
        axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
        axios.post(
            ServerProperties.ATM_CLOUD.API+'Booking/Reservation/Register/',
            {
                Asset      : params.data.Asset,
                StartDate  : params.data.StartDate,
                FinishDate : params.data.FinishDate,
                Site       : params.data.Site,
                Location   : params.data.Location,
                Description: params.data.Description,
            }
        )
        .then(function (response) {
            params.onsuccess(params, response)
        })
        .catch(error => {
            console.log(error)
            params.onfailed(error.response)
        });
    },
    RegisterNote: function(params) {
        axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
        axios.post(
            ServerProperties.ATM_CLOUD.API+'Message/Note/',
            {
                Asset       : params.data.Asset,
                Name        : params.data.Name,
                Description : params.data.Description
            }
        )
        .then(function (response) {
            params.onsuccess(params, response)
        })
        .catch(error => {
          params.onfailed(error.response)
          console.log(error);
        });
    },
    RequestMaintenance: function(params) {
      axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
      axios.post(
        ServerProperties.ATM_CLOUD.API + 'Maintenance/Request/Register/',
        params.data.field
      )
      .then(function (response) {
        params.onsuccess(params, response)
      })
      .catch(error => {
        console.log(error.response)
        params.onfailed(error.response)
      });
    }


}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/model.js